import React, { useState, useEffect } from 'react';
import { getMonthNameById } from '../services/MyCollections';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Box, TextField, Typography } from '@mui/material';
import Controls from "./controls/Controls";

export default function ConfirmPaymentDialog({
    open,
    handleClose,
    handleConfirmPayments,
    month,
    year,
    accountants,
    signature,
    date,
    partiallyPayedAmount,
    darkTheme
}) {
    const [amount, setAmount] = useState(partiallyPayedAmount);
    const [isPartiallyPayed, setIsPartiallyPayed] = useState(partiallyPayedAmount !== null);

    // Resetowanie stanu przy otwarciu okna dialogowego
    useEffect(() => {
        if (open) {
            setAmount(partiallyPayedAmount);
            setIsPartiallyPayed(partiallyPayedAmount !== null);
        }
    }, [open]);

    const handleConfirmClick = () => {
        if (isPartiallyPayed) {
            handleConfirmPayments(amount)
        }
        else {
            handleConfirmPayments()
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="confirm-dialog-title">
            <DialogTitle id="confirm-dialog-title" sx={{ backgroundColor: darkTheme ? '#0f0f0f' : '#f5f5f5', fontWeight: 'bold', mb: 2 }}>
                Potwierdzenie przelewów
            </DialogTitle>
            <DialogContent>
                <Box mb={3}>
                    <Typography variant="body1" gutterBottom>
                        Potwierdzam realizację przelewów za zestawienie <strong>{getMonthNameById(month)} {year}</strong> do:
                    </Typography>
                </Box>

                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '8px', p: 2, mb: 3, backgroundColor: darkTheme ? '#0f0f0f' : '#fafafa' }}>
                    <Grid container spacing={1}>
                        {accountants.map((accountant, index) => (
                            <Grid item xs={12} key={index}>
                                <Typography variant="body2">
                                    <strong>{index + 1}. {accountant}</strong>
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {accountants.length < 2 && (
                    <Box mb={2}>
                        <Controls.Checkbox
                            name="isPartiallyPayed"
                            value={isPartiallyPayed}
                            onChange={(e) => setIsPartiallyPayed(e.target.value)}
                            label="Zapłacone częściowo?"
                        />
                    </Box>
                )}

                {isPartiallyPayed && (
                    <TextField
                        label="Kwota przelewu brutto"
                        placeholder="0.00"
                        fullWidth
                        margin="normal"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        type="number"
                        inputProps={{ min: 0, step: 0.01 }}
                    />
                )}

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                            Data: <strong><i>{date}</i></strong>
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                            Podpis: <strong><i>{signature}</i></strong>
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ backgroundColor: darkTheme ? '#0f0f0f' : '#f5f5f5', p: 2 }}>
                <Button color="secondary" variant="outlined" onClick={handleClose} sx={{ mr: 1 }}>Anuluj</Button>
                <Button variant="contained" onClick={handleConfirmClick} sx={{ backgroundColor: '#1976d2', color: '#fff', '&:hover': { backgroundColor: '#1565c0' } }}>
                    Zatwierdź
                </Button>
            </DialogActions>
        </Dialog>
    );
}
